// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "uft-8";

.billboard_main_container__8K60f {
  display: flex;
  height: calc((var(--vh, 1vh) * 100) - 101px);
}

.billboard_map_container__gZ8lk {
  /* width: 54vw; */
  flex: 1 1;
  /* min-height: calc(100vh - 150px); */
  background-color: aliceblue;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
}

.billboard_map_container__gZ8lk div:focus-visible {
  outline: none;
}

.billboard_billboard_list_wrapper__-tehj {
  /* width: 448px; */
  width: 414px;
  /* flex-grow: 1; */
  padding: 10px 0 0 0;
  /* padding: 0; */
  /* margin-left: 10px; */
  background-color: #fff;
}

.billboard_billboard_list_scroll__BPavZ {
  height: calc(100vh - 109px);
  overflow-y: auto;
  /* padding-top: 8px; */
}

.billboard_items__42A-r {
  background-color: #f2f2f2;
  /* height: 154.75px; */
  display: flex;
  margin: 0px 8px;
}

/* .items:first-of-type {
  margin-top: 8px;
} */

.billboard_items__42A-r.billboard_checked__cPfc4 {
  background: #fff2e9;
}

.billboard_items__42A-r .billboard_img_wrapper__g8cdW {
  position: relative;
  width: 200px;
  aspect-ratio: 4 / 3;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.billboard_img_wrapper__g8cdW img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.5s ease-in-out;
  position: relative;
  z-index: 1;
}

.billboard_img_wrapper__g8cdW img:hover {
  width: 110%;
  height: 110%;
}

.billboard_img_wrapper__g8cdW video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  z-index: 3;
}

.billboard_img_wrapper__g8cdW video.billboard_show__ZAdIl {
  opacity: 1;
}

.billboard_infoBox__zZwoC {
  /* width: 170px; */
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 16px 12px 8px 8px;
}

.billboard_info_small__c2pVY {
  padding-top: 22px;
  line-height: 1;
}

.billboard_infoBoxName__lYJMa {
  color: #000;
  font-family: NanumSquare Neo;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: 160%;
}

.billboard_hoverUnderline__lHpM7:hover {
  text-decoration: underline;
}

.billboard_map_title__1G4pF {
  font-size: 27.5px;
  font-weight: 800;
}

.billboard_infoBox__zZwoC.billboard_w_auto__s28Kp {
  width: auto;
}

@media (max-width: 1280px) {
  .billboard_map_title__1G4pF {
    font-size: 20px;
  }

  .billboard_main_container__8K60f {
    padding-left: 0;
  }

  .billboard_map_container__gZ8lk {
    width: 100vw;
  }

  .billboard_billboard_list_wrapper__-tehj {
    padding-right: 0;
  }

  .billboard_items__42A-r {
    margin: 0 6.91px 0 0;
    flex-direction: column;
    /* height: calc(100% - 6.91px); */
    height: 100%;
  }

  .billboard_infoBox__zZwoC {
    width: 170px;
    padding: 2.28px 3.8px 3.3px 4.69px;
    flex-grow: 1;
  }

  .billboard_mobile_info__L87DY {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: 3.8px;
    margin-bottom: 7.47px;
  }

  .billboard_mobile_items_wrapper__iILid {
    position: absolute;
    /* height: 268px; */
    /* width: calc(100vw - 24px); */
    width: 100vw;
    bottom: 75.9px;
    overflow-x: auto;
    /* margin-bottom: 4.83px; */
    left: 50%;
    transform: translateX(-50%);
    /* padding-bottom: 4px; */
    z-index: 2;
  }

  .billboard_mobile_items_wrapper__iILid::-webkit-scrollbar {
    display: none;
  }

  .billboard_mobile_items_wrapper__iILid {
    -ms-overflow-style: none;
    /* 인터넷 익스플로러 */
    scrollbar-width: none;
    /* 파이어폭스 */
  }

  .billboard_mobile_items_wrapper__iILid::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 3px;
    /* border-radius: 4px; */
  }

  .billboard_mobile_items_wrapper__iILid::-webkit-scrollbar-track {
    background-color: transparent;
  }
}

@media (max-width: 768px) {
  .billboard_main_container__8K60f {
    padding-top: 0;
  }

  .billboard_map_container__gZ8lk {
    margin-right: 0;
  }
}

@media (max-width: 480px) {
  .billboard_items__42A-r {
    width: 33vw;
  }

  .billboard_items__42A-r .billboard_img_wrapper__g8cdW {
    width: 100%;
    aspect-ratio: 5 / 3;
  }

  .billboard_infoBox__zZwoC {
    width: 100px;
  }

  /*
  .mobile_items_wrapper {
    bottom: 90.9px;
  } */
}

@media (max-height: 800px) and (max-width: 1279px) {
  .billboard_items_height__bRWvO {
    width: 33vw !important;
  }

  .billboard_img_wrapper__g8cdW {
    width: 100% !important;
    aspect-ratio: 5 / 3 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/billboard.module.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,SAAO;EACP,qCAAqC;EACrC,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kCAAkC;IAClC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;;;KAGG;AACL;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;AACF","sourcesContent":["@charset \"uft-8\";\n\n.main_container {\n  display: flex;\n  height: calc((var(--vh, 1vh) * 100) - 101px);\n}\n\n.map_container {\n  /* width: 54vw; */\n  flex: 1;\n  /* min-height: calc(100vh - 150px); */\n  background-color: aliceblue;\n  /* margin-left: 10px; */\n  /* margin-right: 10px; */\n}\n\n.map_container div:focus-visible {\n  outline: none;\n}\n\n.billboard_list_wrapper {\n  /* width: 448px; */\n  width: 414px;\n  /* flex-grow: 1; */\n  padding: 10px 0 0 0;\n  /* padding: 0; */\n  /* margin-left: 10px; */\n  background-color: #fff;\n}\n\n.billboard_list_scroll {\n  height: calc(100vh - 109px);\n  overflow-y: auto;\n  /* padding-top: 8px; */\n}\n\n.items {\n  background-color: #f2f2f2;\n  /* height: 154.75px; */\n  display: flex;\n  margin: 0px 8px;\n}\n\n/* .items:first-of-type {\n  margin-top: 8px;\n} */\n\n.items.checked {\n  background: #fff2e9;\n}\n\n.items .img_wrapper {\n  position: relative;\n  width: 200px;\n  aspect-ratio: 4 / 3;\n  background-color: #f8f8f8;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.img_wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: all 0.5s ease-in-out;\n  position: relative;\n  z-index: 1;\n}\n\n.img_wrapper img:hover {\n  width: 110%;\n  height: 110%;\n}\n\n.img_wrapper video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n  z-index: 3;\n}\n\n.img_wrapper video.show {\n  opacity: 1;\n}\n\n.infoBox {\n  /* width: 170px; */\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 12px 8px 8px;\n}\n\n.info_small {\n  padding-top: 22px;\n  line-height: 1;\n}\n\n.infoBoxName {\n  color: #000;\n  font-family: NanumSquare Neo;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 160%;\n}\n\n.hoverUnderline:hover {\n  text-decoration: underline;\n}\n\n.map_title {\n  font-size: 27.5px;\n  font-weight: 800;\n}\n\n.infoBox.w_auto {\n  width: auto;\n}\n\n@media (max-width: 1280px) {\n  .map_title {\n    font-size: 20px;\n  }\n\n  .main_container {\n    padding-left: 0;\n  }\n\n  .map_container {\n    width: 100vw;\n  }\n\n  .billboard_list_wrapper {\n    padding-right: 0;\n  }\n\n  .items {\n    margin: 0 6.91px 0 0;\n    flex-direction: column;\n    /* height: calc(100% - 6.91px); */\n    height: 100%;\n  }\n\n  .infoBox {\n    width: 170px;\n    padding: 2.28px 3.8px 3.3px 4.69px;\n    flex-grow: 1;\n  }\n\n  .mobile_info {\n    display: flex;\n    flex-direction: column;\n    margin-left: auto;\n    margin-right: 3.8px;\n    margin-bottom: 7.47px;\n  }\n\n  .mobile_items_wrapper {\n    position: absolute;\n    /* height: 268px; */\n    /* width: calc(100vw - 24px); */\n    width: 100vw;\n    bottom: 75.9px;\n    overflow-x: auto;\n    /* margin-bottom: 4.83px; */\n    left: 50%;\n    transform: translateX(-50%);\n    /* padding-bottom: 4px; */\n    z-index: 2;\n  }\n\n  .mobile_items_wrapper::-webkit-scrollbar {\n    display: none;\n  }\n\n  .mobile_items_wrapper {\n    -ms-overflow-style: none;\n    /* 인터넷 익스플로러 */\n    scrollbar-width: none;\n    /* 파이어폭스 */\n  }\n\n  .mobile_items_wrapper::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 3px;\n    /* border-radius: 4px; */\n  }\n\n  .mobile_items_wrapper::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n}\n\n@media (max-width: 768px) {\n  .main_container {\n    padding-top: 0;\n  }\n\n  .map_container {\n    margin-right: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .items {\n    width: 33vw;\n  }\n\n  .items .img_wrapper {\n    width: 100%;\n    aspect-ratio: 5 / 3;\n  }\n\n  .infoBox {\n    width: 100px;\n  }\n\n  /*\n  .mobile_items_wrapper {\n    bottom: 90.9px;\n  } */\n}\n\n@media (max-height: 800px) and (max-width: 1279px) {\n  .items_height {\n    width: 33vw !important;\n  }\n\n  .img_wrapper {\n    width: 100% !important;\n    aspect-ratio: 5 / 3 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_container": `billboard_main_container__8K60f`,
	"map_container": `billboard_map_container__gZ8lk`,
	"billboard_list_wrapper": `billboard_billboard_list_wrapper__-tehj`,
	"billboard_list_scroll": `billboard_billboard_list_scroll__BPavZ`,
	"items": `billboard_items__42A-r`,
	"checked": `billboard_checked__cPfc4`,
	"img_wrapper": `billboard_img_wrapper__g8cdW`,
	"show": `billboard_show__ZAdIl`,
	"infoBox": `billboard_infoBox__zZwoC`,
	"info_small": `billboard_info_small__c2pVY`,
	"infoBoxName": `billboard_infoBoxName__lYJMa`,
	"hoverUnderline": `billboard_hoverUnderline__lHpM7`,
	"map_title": `billboard_map_title__1G4pF`,
	"w_auto": `billboard_w_auto__s28Kp`,
	"mobile_info": `billboard_mobile_info__L87DY`,
	"mobile_items_wrapper": `billboard_mobile_items_wrapper__iILid`,
	"items_height": `billboard_items_height__bRWvO`
};
export default ___CSS_LOADER_EXPORT___;
